import { render } from "./Claim4_Main.vue?vue&type=template&id=34d47876&scoped=true"
import script from "./Claim4_Main.vue?vue&type=script&lang=js"
export * from "./Claim4_Main.vue?vue&type=script&lang=js"

import "./Claim4_Main.vue?vue&type=style&index=0&id=34d47876&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-34d47876"

export default script